import React, {useEffect, useState} from 'react'
import RatingAccessAssessment from "../../views/ver_24.10/ProgramRating/RatingAccessAsssessment.view";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {getOrgDetails, listOrgModules, updateOrgCallbackInfo} from "../../services/certify.service";
import {APP_STATUS, TOAST_TYPES} from "../../utils/constants";
import {
    getApplicationService
} from "../../services/app.service";
import {useLocation, useParams} from "react-router-dom";
import {publishProgramAssessmentService} from "../../services/rating.service";
import {toast} from "../../utils/utils";
import {ASSESSMENT_STEPS} from "../../utils/RatingFlowSteps";

const RatingAccessAssessmentPage = () => {
    const { programId } = useParams();
    const location = useLocation();
    const [status, setStatus] = useState();
    const [app, setApp] = useState();
    const [showLoader, setShowLoader] = useState(false);
    const [orgCode, setOrgCode] = useState(false);
    const [orgInfo, setOrgInfo] = useState(undefined);
    const [orgModules, setOrgModules] = useState(undefined);
    const currentStatus = location.state?.currentStatus || 'ACCESS_ASSESS_DASH';


    const [isEditing, setIsEditing] = useState({
        callback_url: false,
        callback_key: false
    });
    const [tempValues, setTempValues] = useState({
        callback_url: orgInfo?.callback_url || '',
        callback_key: orgInfo?.callback_key || ''
    });

    const loadAppData = async () => {
        console.log('Loading App Data...');
        try {
            setShowLoader(true);
            const result = await getApplicationService(programId);
            if (!result.error && result.data) {
                console.log('App Data: ', result.data);
                setApp(result.data);
                setStatus(result.data.app_status);
                if (result.data.assessments_approve_info?.org_code) {
                    setOrgCode(result.data.assessments_approve_info.org_code);
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setShowLoader(false);
        }
    };


    useEffect(() => {
        console.log('programId:', programId);
        loadAppData().then((res) => `fetch initiated, ${res}`);
    }, []);

    useEffect(() => {
        if (orgCode) {
            fetchOrganizationInfo().then((res) => `org details fetched, ${res}`);
            fetchOrganizationModules().then((res) => `org modules fetched, ${res}`);
        }
    }, [orgCode]);

    const fetchOrganizationInfo =  async () => {
        try {
            const result = await getOrgDetails(orgCode);
            console.log('mna: result.data -> ', result.data);
            if (result.data && result.data.org_object) {
                setOrgInfo(result.data.org_object);
            }
        }
        catch (e) {
            //already toasted
        }
    }

    const fetchOrganizationModules =  async () => {
        try {
            const result = await listOrgModules(orgCode);
            console.log('mna: result.data -> ', result.data);
            if (result.data && result.data.modules) {
                setOrgModules(result.data.modules);
            }
        }
        catch (e) {
            //already toasted
        }
    }

    const editAction = (field) => {
        setIsEditing({
            ...isEditing,
            [field]: true
        });
        setTempValues({
            ...tempValues,
            [field]: orgInfo[field]
        });
    };

    const saveAction = async (field) => {
        console.log(`Saving ${field}:`, tempValues[field]);
        setIsEditing({
            ...isEditing,
            [field]: false
        });

        // call the backed.
        try {
            const result = await updateOrgCallbackInfo(orgCode, {[field]: tempValues[field]});
            console.log('mna: result.data -> ', result.data);
            if (result.data && result.data.success && result.data.org_object) {
                setOrgInfo(result.data.org_object);
            }
        }
        catch (e) {
            //already toasted
        }
    };

    const inputChangeAction = (field, e) => {
        setTempValues({
            ...tempValues,
            [field]: e.target.value
        });
    };

    const goToDqAssessAction = () => {
        if (app && app.assessments_approve_info) {
            const username_q = app.assessments_approve_info.demo_dq_assess_user;
            const password_q = app.assessments_approve_info.demo_dq_assess_pass;
            window.open(`${process.env.REACT_APP_MYDQ_APP_LOGIN_URL}?username=${username_q}&password=${password_q}`, '_blank');
        } else {
            window.open(process.env.REACT_APP_MYDQ_APP_LOGIN_URL, '_blank');
        }
    }

    const goToDqDashboardAction = () => {
        window.open(process.env.REACT_APP_ANALYTICS_PORTAL_LOGIN_URL, '_blank');
    }

    const goToDqAssessmentAction = () => {
        window.open(process.env.REACT_APP_MYDQ_APP_LOGIN_URL, '_blank');
    }

    const publishAssessmentAction = async () => {
        try {
            setShowLoader(true);
            const result = await publishProgramAssessmentService(programId)
            if (!result.error && result.data) {
                setApp(result.data.program_application);
                toast(TOAST_TYPES.SUCCESS, "Published", "Assessments Successfully Published");
            }
        } catch (error) {

        } finally {
            setShowLoader(false);
        }
    }

    const options = {
        showLoader,
        isEditing
    };

    const actions = {
        inputChangeAction,
        saveAction,
        editAction,
        goToDqAssessAction,
        goToDqDashboardAction,
        goToDqAssessmentAction,
        publishAssessmentAction
    };

    const data = {
        app,
        status,
        tempValues,
        orgModules,
        orgInfo,
        ASSESSMENT_STEPS,
        currentStatus,
    };

    if (showLoader) {
        return <Loader />;
    }

     return(
         <RatingAccessAssessment
             options={options}
             actions={actions}
             data={data}
         />
     );
}

export default RatingAccessAssessmentPage;